import { Theme as MuiTheme, useMediaQuery } from '@mui/material';
import React from 'react';
import { Tier } from '@gamiphy/bl/level';
import { FreeShippingApi } from '@gamiphy/gamix-modules/freeShipping';
import { AppFreeShipping } from '@gamiphy/bl/freeShipping';
import { useTranslation } from '@gamiphy/react-i18n';

export const useIsSmallScreen = (): boolean => useMediaQuery<MuiTheme>((theme) => theme.breakpoints.down('sm'));

export const useBenefitsList = (levels: Tier[]): {
  benefitsTableData: [string, ...boolean[]][],
  mobileFormattedData: { [key: string]: string[] }
} => {
  const { t } = useTranslation();
  const [freeShipping, setFreeShipping] = React.useState<AppFreeShipping[]>([]);
  const benefits = React.useMemo(() => {
    const output = [];
    const mobileFormattedData: { [key: string]: string[] } = {};
    let benefitsArr: string[] = [];
    const freeShippingBenefit: [string, ...boolean[]] = [t('level.freeShipping', 'Free Shipping')];
    for (let i = 0; i < levels?.length; i += 1) {
      if (!mobileFormattedData[levels[i].id]) {
        mobileFormattedData[levels[i].id] = [];
      }
      if (freeShipping.find((item) => item.tier === levels[i].id && item.enabled)) {
        freeShippingBenefit.push(true);
        mobileFormattedData[levels[i].id].push(t('level.freeShipping', 'Free Shipping'));
      } else {
        freeShippingBenefit.push(false);
      }

      if (levels[i].benefits) {
        const newBenefits = levels[i].benefits?.map((benefit) => benefit.en) || [];
        benefitsArr = [...benefitsArr, ...newBenefits];
        mobileFormattedData[levels[i].id].push(...newBenefits);
      }
    }
    output.push(freeShippingBenefit);
    benefitsArr = Array.from(new Set(benefitsArr));
    for (let i = 0; i < benefitsArr?.length; i += 1) {
      const benefitsRow: [string, ...boolean[]] = [benefitsArr[i]];
      for (let j = 0; j < levels?.length; j += 1) {
        if (levels[j].benefits?.find((benefit) => benefitsArr[i] === benefit.en)) {
          benefitsRow.push(true);
        } else {
          benefitsRow.push(false);
        }
      }
      output.push(benefitsRow);
    }
    return {
      benefitsTableData: output,
      mobileFormattedData,
    };
  }, [freeShipping, levels]);

  React.useEffect(() => {
    void (async () => {
      setFreeShipping(await FreeShippingApi.getAppFreeShippingList());
    })();
  }, []);

  return {
    benefitsTableData: benefits.benefitsTableData,
    mobileFormattedData: benefits.mobileFormattedData,
  };
};
